import AspectRatio from '@blocks/AspectRatio'
import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import Image from '@blocks/Input/Image'
import React from 'react'

export default function OrganizationForm({ model: organization }: Modules.Resource.Form<Interfaces.Organization>) {
    return (
        <Grid columns="2">
            <AspectRatio width={1} height={1}>
                <Image id="logo" name="logo" src={organization?.logo_url} />
            </AspectRatio>
            <Grid>
                <Input id="name" name="name" label="Name" placeholder="FIAP" defaultValue={organization?.name} required />
                <Input id="full_name" name="full_name" label="Full name" placeholder="International Federation of Photographic Art" defaultValue={organization?.full_name} required />
                <Input id="label" name="label" label="Label" placeholder="Patronage" defaultValue={organization?.label} required />
            </Grid>
        </Grid>
    )
}